import * as React from 'react';
import { FormControl, InputLabel } from '@mui/material';

import styles from './styles.module.scss';

type InputProps = {
  id: string;
  label?: string;
  disabled?: boolean;
  children: React.ReactNode;
};

export const FormControlWithStatus = ({
  id,
  label,
  disabled = false,
  children,
}: InputProps) => {
  return (
    <FormControl
      variant="outlined"
      disabled={disabled}
      classes={{
        root: styles.formControl,
      }}
    >
      {label && (
        <InputLabel
          htmlFor={id}
          color="secondary"
          classes={{
            root: styles.label,
            focused: styles.labelFocused,
            shrink: styles.labelFocused,
          }}
        >
          {label}
        </InputLabel>
      )}
      {children}
    </FormControl>
  );
};
